import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["src"]

import { IonThumbnail } from '@ionic/vue';
import { defineComponent } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ItemWithThumbnail',
  props: {
  imageSource: {
    type: String,
    default: 'https://ionicframework.com/docs/demos/api/card/madison.jpg',
  },
},
  setup(__props) {


defineComponent({ name: 'ItemWithThumbnail', components: { IonThumbnail } });

return (_ctx: any,_cache: any) => {
  const _component_ion_item = _resolveComponent("ion-item")!

  return (_openBlock(), _createBlock(_component_ion_item, {
    lines: "none",
    class: "position-relative"
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(IonThumbnail), {
        slot: "start",
        style: {"--size":"80px"}
      }, {
        default: _withCtx(() => [
          _createElementVNode("img", {
            alt: "Silhouette of mountains",
            src: __props.imageSource,
            class: "rounded"
          }, null, 8, _hoisted_1)
        ]),
        _: 1
      }),
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }))
}
}

})